// eslint-disable-next-line no-restricted-imports
import { datadogLogs } from '@datadog/browser-logs';

export function apiKeyLogger(error: any, ctx: any) {
  datadogLogs.logger.error(error, ctx);
}
